import { createAction, props } from "@ngrx/store";
import { StandingAuthorizationForm } from "../models/standingAuthorizationForm";
import { DistributionReason } from "../../create-request/models/internal-transfer/DistributionReason";
import { TransactionType } from "../../shared/types/Transaction";

export const updateFormValue = createAction(
    '[Create Standing Authorization - Standing Auth Form] Update form value',
    props<Partial<StandingAuthorizationForm>>()
);

export const updateFormStatus = createAction(
    '[Create Standing Authorization - Standing Auth Form] Update form status',
    props<{ valid: boolean }>()
);

export const transactionTypeChanged = createAction(
    '[Create Standing Authorization - Standing Auth Form] Transaction type changed',
    props<{ transactionType: string }>()
);

export const loadReviewPage = createAction(
    '[Create Standing Authorization - Standing Auth Form] Load Review page'
);

export const cancelClicked = createAction(
    '[Create Request - Standing Authorization Form] Cancel clicked'
);

export const initializeServiceError = createAction(
    '[Create Standing Authorization - Standing Auth Form] Standing Auth Form service error initialized'
);

export const editLoadComplete = createAction(
    '[Edit Standing Authorization - Standing Auth Form] Edit loading completed'
);

export const distributionReasonChanged = createAction(
    '[Create Standing Authorization - Standing Auth Form] Update selected distribution reason',
    props<{ distributionReason: DistributionReason, transactionType: TransactionType | '' }>()

)
